
export const isVariantImagePackshot = (variantImage) => {
  return variantImage && variantImage.originalSrc && isPackshotImage(variantImage.originalSrc)
}

export const isPackshotImage = (imageName) => {
  if (typeof imageName === "undefined" || !imageName) {
    return false;
  }

  const imageNameString = imageName.toLowerCase();

  return (
    imageNameString.includes(".png") ||
    imageNameString.includes("packshot") ||
    imageNameString.includes("image/png")
  )
}




const generateSrcSet = (originalSrc, width, aspectRatio, extension = '') => {
  const sizes = [1, 1.5]
  const ratio = [1, 2];
  return sizes.map((size, index) => {
    const w = Math.round(width * size);
    const h = Math.round(w / aspectRatio);
    const newImage = `${originalSrc.replace(/(\.[a-z]+)(\?v=[0-9]+)/, `_${w}x${h}_crop_center$1${extension}$2`)} ${ratio[index]}x`;
    return newImage
  }).join(',\n');
};

//

/**
 * Generate gatsby image data for an image
 * 
 * @param {*} originalSrc 
 * @param {*} width 
 * @param {*} aspectRatio 
 * @returns 
 */
export const yytGatsbyImageData = (originalSrc, width, aspectRatio = 1) => {
  const srcSet = generateSrcSet(originalSrc, width, aspectRatio, '.webp');
  const height = Math.round(width / aspectRatio);
  const fallbackSrc = originalSrc.replace(/(\.[a-z]+\?v=[0-9]+)/, `_${width}x${height}_crop_center$1`);
  const fallbackSrcSet = generateSrcSet(originalSrc, width, aspectRatio);

  return {
    images: {
      sources: [
        {
          srcSet: srcSet,
          sizes: `(min-width: ${width}px) ${width}px, 100vw`,
          type: "image/webp"
        }
      ],
      fallback: {
        src: fallbackSrc,
        srcSet: fallbackSrcSet,
        sizes: `(min-width: ${width}px) ${width}px, 100vw`
      }
    },
    layout: "constrained",
    width: width,
    height: height
  };
};


/**
 * Generate the image data for a list of Shopify Product
 * 
 * @param {*} products 
 * @returns 
 */
export const mapProductsWithImages = (products) => {
  const imageWidth = 600;
  return products?.map(product => ({
    ...product,
    media: product.media.map(media => {
      return {
        id: media.id,
        image: media?.image ? {
          ...media?.image,
          gatsbyImageData: yytGatsbyImageData(media?.image.originalSrc, imageWidth),
          portrait: yytGatsbyImageData(media?.image.originalSrc, imageWidth, 0.82835820895)
        } : null
      }
    }),
    variants: product.variants.map(variant => ({
      ...variant,
      media: variant?.media?.map(media => {
        return {
          id: media.id,
          image: media?.image ? {
            ...media?.image,
            gatsbyImageData: yytGatsbyImageData(media?.image.originalSrc, imageWidth),
            portrait: yytGatsbyImageData(media?.image.originalSrc, imageWidth, 0.82835820895)
          } : null
        }
      })
    }))
  }))
}